<template>
    <v-container class="mt-10">
        <v-row dense>
            <v-col cols="12" v-for="job in jobs" :key="job.jobId"  lg="3">
                <job-detail :job="job">

                </job-detail>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import JobDetail from './JobDetail'
    export default {
        props: ["jobs"],
        name: "JobList.vue",
        components: {
            JobDetail,
        },
        data () {
            return {}
        }
    }
</script>

<style scoped>

</style>
